<template>
    <div>
      <div class="modal hide fade" id="modalPurchasingImportTax" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingImportTax" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Import File</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <label for="company_no">Company</label>
                    <select v-model="company_no" class="form-control">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                    <label for="bank_id">Bank</label>
                    <select v-model="bank_id" class="form-control">
                        <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }} {{ b.account_no }}</option>
                    </select>
                    <input type="file" id="file" ref="file" />
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestEdit">Process</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LedgerBankImportModal',
  data () {
    return {
      company_no: null,
      bank_id: null,
      max: 100,
      request_edit: '',
      request_void: '',
      file: null
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList,
      bankList: state => state.banks.bankList,
      authUser: state => state.users.authUser
    })
  },
  methods: {
    requestEdit () {
      this.file = this.$refs.file.files[0]
      var data = {
        company_no: this.company_no,
        bank_id: this.bank_id,
        file: this.file
      }
      this.$emit('getUploadFile', data)
    }
  }
}
</script>
